import React, {useEffect, useState, useRef, useCallback} from 'react';
import "./PlannogrammListStyle.css"
import {NavLink, useNavigate} from "react-router-dom";
import {decodeTokens, useButtonLock} from "../../../utils/js/request";
import {GET_ROLE, PLANNOGRAMM, PLANNOGRAMM_ADDTASCK} from "../../../utils/js/Const";
import {v4 as uuidv4} from 'uuid';

import plus from "./img/plus.svg"

import ButtonPlusImg from "../../../components/Buttons/buttonHint/ButtonPlusImg";
import {FetchElements} from "../../../utils/js/request";
import CustomSearch2 from "../../../components/CustomSearch2/CustomSearch2";
import {HandySvg} from "handy-svg";

import closeTasksSVG from "./img/closeTasks.svg"
import trash from "./img/trash.svg"
import {NexTitle} from "../../../utils/js/UtilsJs";
import CustomAlert from "../../../components/CustomAlert/CustomAlert";
import Reload from "../../../components/Buttons/ReloadBut/Reload";


function PlannogrammList( {  } ) {

    NexTitle("Планограммы")
    let navigate = useNavigate();
    let role = GET_ROLE();
    const BoolMass = [{id:true, name:"да"},{id:false, name:"нет"}];

    function purposeId (){
        return uuidv4()
    }

    //ObserWard
    const LIMIT = 50;

    const [offset, setOffset] = useState(0);
    const [hasMore, setHasMore] = useState(true);
    const [loading, setLoading] = useState(false);

    const observerDesktop = useRef();
    const observerMobile = useRef();

// Реф для десктопной версии
    const lastTaskElementRefDesktop = useCallback(node => {
        if (loading) return;
        if (observerDesktop.current) observerDesktop.current.disconnect();

        observerDesktop.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setOffset(prev => prev + LIMIT);
            }
        });

        if (node) observerDesktop.current.observe(node);
    }, [loading, hasMore]);

// Реф для мобильной версии
    const lastTaskElementRefMobile = useCallback(node => {
        if (loading) return;
        if (observerMobile.current) observerMobile.current.disconnect();

        observerMobile.current = new IntersectionObserver(entries => {
            if (entries[0].isIntersecting && hasMore) {
                setOffset(prev => prev + LIMIT);
            }
        });

        if (node) observerMobile.current.observe(node);
    }, [loading, hasMore]);

    // стейты с данными из запросов
    const [statuses, setStatuses] = useState([])
    const [priorities, setPriorities] = useState([])
    const [shops, setShops] = useState([])
    const [taskName, setTaskName] = useState([])
    const [kust, setKust] = useState([])
    const [users, setUsers] = useState([])
    const [tasks, setTasks] = useState([])

    // стейты с данными из селектов
    const [statusIdFromChild, setStatusIdFromChild] = useState();         // айдишник статсуа
    const [statusNameFromChild, setStatusNameFromChild] = useState()      // название статсуа
    const [prioritiesIdFromChild, setPrioritiesIdFromChild] = useState(); // айдишник приоритета
    const [prioritiesNameFromChild, setPrioritiesNameFromChild] = useState()     // название приоритета
    const [nameFromChild, setNameFromChild] = useState();                 // название
    const [shopIdFromChild, setShopIdFromChild] = useState()              // айдишник магазина
    const [shopNameFromChild, setShopNameFromChild] = useState()          // название магазина
    const [kustIdFromChild, setKustIdFromChild] = useState();             // айдишник куста
    const [kustNameFromChild, setKustNameFromChild] = useState()          // название магазина
    const [userIdFromChild, setUserIdFromChild] = useState();             // айдишник пользоваетля
    const [userNameFromChild, setUserNameFromChild] = useState()          // название магазина
    const [dataTimeStart, setDataTimeStart] = useState();                 // дата начала
    const [dataTimeEnd, setDataTimeEnd] = useState();                     // дата окончания
    const [dataTimeClose, setDataTimeClose] = useState();                 // дата завершения
    const [gv, setGv] = useState();                                       // название ГВ
    const [gvBooleanData, setGvBooleanData] = useState()                  // значение ГВ

    // стейты сортировки
    const [sortedstatusIdFromChild, setSortedStatusIdFromChild] = useState(null);           // айдишник статсуа
    const [sortedprioritiesIdFromChild, setSortedPrioritiesIdFromChild] = useState(null);   // айдишник приоритета
    const [sortednameFromChild, setSortedNameFromChild] = useState(null);                   // название
    const [sortedshopIdFromChild, setSortedShopIdFromChild] = useState(null)                // айдишник магазина
    const [sortedkustIdFromChild, setSortedKustIdFromChild] = useState(null);               // айдишник куста
    const [sorteduserIdFromChild, setSortedUserIdFromChild] = useState(null);               // айдишник пользоваетля
    const [sorteddataTimeStartAndEnd, setSortedDataTimeStartAndEnd] = useState(null);       // дата начала и окончания
    const [sorteddataTimeClose, setSortedDataTimeClose] = useState(null);                   // дата завершения

    const [dataLoading, setDataLoading] = useState(false)

    const [isInitialized, setIsInitialized] = useState(false);

    const [isOpenAlert, setIsOpenAlert] = useState(false);
    const [alertMessage, setAlertMessage] = useState('');
    const [alertTitle, setAlertTitle] = useState('');
    const [alertStatusCod, setAlertStatusCod] = useState('')

    //Стейт для очистки фильтров
    const [clearFull, setClearFull] = useState(false);

    //Универсальный блокиратор отправки повторных запросов
    const { isDisabled, lockButton, unlockButton } = useButtonLock();

    const handleOpenAlert = (title, message, statusCod) => {
        setAlertTitle(title);
        setAlertMessage(message);
        setAlertStatusCod(statusCod);
        setIsOpenAlert(true);
    };

    const handleCloseAlert = () => {
        setIsOpenAlert(false);
    };

    useEffect(() => {
        LoadData();
        decodeTokens();
        setDataLoading(true);
    }, []);

    const buildUrl = () => {
        const queryParams = [];

        // Универсальная функция добавления параметров
        const addParam = (key, value, isSort = false) => {
            if (value === null || value === undefined || value === '') return;
            queryParams.push(`${key}=${isSort ? (value ? 'up' : 'down') : encodeURIComponent(value)}`);
        };

        // Статус
        if (sortedstatusIdFromChild !== null) {
            addParam('status', sortedstatusIdFromChild, true);
        } else {
            addParam('status', statusIdFromChild);
        }

        // Приоритет
        if (sortedprioritiesIdFromChild !== null) {
            addParam('priority', sortedprioritiesIdFromChild, true);
        } else {
            addParam('priority', prioritiesIdFromChild);
        }

        // Название
        if (sortednameFromChild !== null) {
            addParam('name', sortednameFromChild, true);
        } else {
            addParam('name', nameFromChild);
        }

        // Магазин
        if (sortedshopIdFromChild !== null) {
            addParam('shop', sortedshopIdFromChild, true);
        } else {
            addParam('shop', shopIdFromChild);
        }

        // Куст
        if (sortedkustIdFromChild !== null) {
            addParam('kust', sortedkustIdFromChild, true);
        } else {
            addParam('kust', kustIdFromChild);
        }

        // Пользователь
        if (sorteduserIdFromChild !== null) {
            addParam('user_guid', sorteduserIdFromChild, true);
        } else {
            addParam('user_guid', userIdFromChild);
        }

        // Даты начала и окончания
        if (sorteddataTimeStartAndEnd !== null) {
            addParam('datetime_begin', sorteddataTimeStartAndEnd, true);
        } else {
            addParam('datetime_begin', dataTimeStart);
            addParam('datetime_end', dataTimeEnd);
        }

        // Дата закрытия
        if (sorteddataTimeClose !== null) {
            addParam('datetime_close', sorteddataTimeClose, true);
        } else {
            addParam('datetime_close', dataTimeClose);
        }

        //ГВ
        if (gvBooleanData !== null) {
            addParam('is_hot_pastries', gvBooleanData);
        }else{
            addParam('is_hot_pastries', gvBooleanData);
        }

        // Формируем итоговый URL
        const baseUrl = `${PLANNOGRAMM}/api/v2/tasks`;
        const queryString = queryParams.length ? '?' + queryParams.join('&') : '';

        return baseUrl + queryString;
    };

    useEffect(() => {
        loadFilters();
        setIsInitialized(true);
    }, []);


    useEffect(() => {
        if (offset === 0) return;
        const url = buildUrl();
        FetchElements(
            `${url}${url.includes('?') ? '&' : '?'}limit=${LIMIT}&offset=${offset}`,
            "GET",
            (data) => {
                if (data.length < LIMIT) {
                    setHasMore(false);
                } else {
                    setHasMore(true);
                }
                setTasks(prev => [...prev, ...data]);
            },
            navigate,
            2,
            () => navigate("/"),
            handleOpenAlert
        );
    }, [offset]);

    useEffect(() => {
            if (isInitialized) {
                saveFilters();
                const url = buildUrl();

                FetchElements(
                    `${url}${url.includes('?') ? '&' : '?'}limit=${LIMIT}&offset=${offset}`,
                    "GET",
                    (data) => {
                        if (data.length < LIMIT) {
                            setHasMore(false);
                        } else {
                            setHasMore(true);
                        }
                        setTasks(data);
                        setDataLoading(false);
                    },
                    navigate,
                    2,
                    () => navigate("/"),
                    handleOpenAlert
                );
            }
        }, [
            isInitialized,
            statusIdFromChild,
            prioritiesIdFromChild,
            nameFromChild,
            shopIdFromChild,
            kustIdFromChild,
            userIdFromChild,
            dataTimeStart,
            dataTimeEnd,
            dataTimeClose,
            sortedstatusIdFromChild,
            sortedprioritiesIdFromChild,
            sortednameFromChild,
            sortedshopIdFromChild,
            sortedkustIdFromChild,
            sorteduserIdFromChild,
            sorteddataTimeStartAndEnd,
            sorteddataTimeClose,
            statusNameFromChild,
            prioritiesNameFromChild,
            shopNameFromChild,
            kustNameFromChild,
            userNameFromChild,
            gv,
            gvBooleanData,
        ]
    );

    /*Сохранения фильтров*/
    const saveFilters = () => {
        const filtersToSave = {
            statusIdFromChild,
            sortedstatusIdFromChild,
            prioritiesIdFromChild,
            sortedprioritiesIdFromChild,
            nameFromChild,
            sortednameFromChild,
            shopIdFromChild,
            sortedshopIdFromChild,
            kustIdFromChild,
            sortedkustIdFromChild,
            userIdFromChild,
            sorteduserIdFromChild,
            dataTimeStart,
            dataTimeEnd,
            dataTimeClose,
            sorteddataTimeStartAndEnd,
            sorteddataTimeClose,
            statusNameFromChild,
            prioritiesNameFromChild,
            shopNameFromChild,
            kustNameFromChild,
            userNameFromChild,
            gv,
            gvBooleanData,
        };

        sessionStorage.setItem('taskFilters', JSON.stringify(filtersToSave));
    };

    useEffect(() => {
        const savedFilters = sessionStorage.getItem('taskFilters');
        if (savedFilters) {
            const parsedFilters = JSON.parse(savedFilters);

            if (parsedFilters.statusIdFromChild !== undefined) setStatusIdFromChild(parsedFilters.statusIdFromChild);
            if (parsedFilters.statusNameFromChild !== undefined) setStatusNameFromChild(parsedFilters.statusNameFromChild);
            if (parsedFilters.sortedstatusIdFromChild !== null) setSortedStatusIdFromChild(parsedFilters.sortedstatusIdFromChild);

            if (parsedFilters.prioritiesIdFromChild !== undefined) setPrioritiesIdFromChild(parsedFilters.prioritiesIdFromChild);
            if (parsedFilters.prioritiesNameFromChild !== undefined) setPrioritiesNameFromChild(parsedFilters.prioritiesNameFromChild);
            if (parsedFilters.sortedprioritiesIdFromChild !== null) setSortedPrioritiesIdFromChild(parsedFilters.sortedprioritiesIdFromChild);

            if (parsedFilters.nameFromChild !== undefined) setNameFromChild(parsedFilters.nameFromChild);
            if (parsedFilters.sortednameFromChild !== null) setSortedNameFromChild(parsedFilters.sortednameFromChild);

            if (parsedFilters.shopIdFromChild !== undefined) setShopIdFromChild(parsedFilters.shopIdFromChild);
            if (parsedFilters.shopNameFromChild !== undefined) setShopNameFromChild(parsedFilters.shopNameFromChild);
            if (parsedFilters.sortedshopIdFromChild !== null) setSortedShopIdFromChild(parsedFilters.sortedshopIdFromChild);

            if (parsedFilters.kustIdFromChild !== undefined) setKustIdFromChild(parsedFilters.kustIdFromChild);
            if (parsedFilters.kustNameFromChild !== undefined) setKustNameFromChild(parsedFilters.kustNameFromChild);
            if (parsedFilters.sortedkustIdFromChild !== null) setSortedKustIdFromChild(parsedFilters.sortedkustIdFromChild);

            if (parsedFilters.userIdFromChild !== undefined) setUserIdFromChild(parsedFilters.userIdFromChild);
            if (parsedFilters.userNameFromChild !== undefined) setUserNameFromChild(parsedFilters.userNameFromChild);
            if (parsedFilters.sorteduserIdFromChild !== null) setSortedUserIdFromChild(parsedFilters.sorteduserIdFromChild);

            if (parsedFilters.dataTimeStart !== undefined) setDataTimeStart(parsedFilters.dataTimeStart);
            if (parsedFilters.dataTimeEnd !== undefined) setDataTimeEnd(parsedFilters.dataTimeEnd);
            if (parsedFilters.sorteddataTimeStartAndEnd !== null) setSortedDataTimeStartAndEnd(parsedFilters.sorteddataTimeStartAndEnd);

            if (parsedFilters.dataTimeClose !== undefined) setDataTimeClose(parsedFilters.dataTimeClose);
            if (parsedFilters.sorteddataTimeClose !== null) setSortedDataTimeClose(parsedFilters.sorteddataTimeClose);

            if (parsedFilters.gv !== undefined) setGv(parsedFilters.gv);
            if (parsedFilters.gvBooleanData !== undefined) setGvBooleanData(parsedFilters.gvBooleanData);

        }

        setIsInitialized(true);
    }, []);

    const loadFilters = () => {
        const savedFilters = sessionStorage.getItem('taskFilters');
        if (savedFilters) {
            const parsedFilters = JSON.parse(savedFilters);

            // Восстановление каждого параметра с проверкой
            if (parsedFilters.statusIdFromChild !== undefined) setStatusIdFromChild(parsedFilters.statusIdFromChild);
            if (parsedFilters.sortedstatusIdFromChild !== null) setSortedStatusIdFromChild(parsedFilters.sortedstatusIdFromChild);

            if (parsedFilters.prioritiesIdFromChild !== undefined) setPrioritiesIdFromChild(parsedFilters.prioritiesIdFromChild);
            if (parsedFilters.sortedprioritiesIdFromChild !== null) setSortedPrioritiesIdFromChild(parsedFilters.sortedprioritiesIdFromChild);

            if (parsedFilters.nameFromChild !== undefined) setNameFromChild(parsedFilters.nameFromChild);
            if (parsedFilters.sortednameFromChild !== null) setSortedNameFromChild(parsedFilters.sortednameFromChild);

            if (parsedFilters.shopIdFromChild !== undefined) setShopIdFromChild(parsedFilters.shopIdFromChild);
            if (parsedFilters.sortedshopIdFromChild !== null) setSortedShopIdFromChild(parsedFilters.sortedshopIdFromChild);

            if (parsedFilters.kustIdFromChild !== undefined) setKustIdFromChild(parsedFilters.kustIdFromChild);
            if (parsedFilters.sortedkustIdFromChild !== null) setSortedKustIdFromChild(parsedFilters.sortedkustIdFromChild);

            if (parsedFilters.userIdFromChild !== undefined) setUserIdFromChild(parsedFilters.userIdFromChild);
            if (parsedFilters.sorteduserIdFromChild !== null) setSortedUserIdFromChild(parsedFilters.sorteduserIdFromChild);

            if (parsedFilters.dataTimeStart !== undefined) setDataTimeStart(parsedFilters.dataTimeStart);
            if (parsedFilters.dataTimeEnd !== undefined) setDataTimeEnd(parsedFilters.dataTimeEnd);
            if (parsedFilters.sorteddataTimeStartAndEnd !== null) setSortedDataTimeStartAndEnd(parsedFilters.sorteddataTimeStartAndEnd);

            if (parsedFilters.dataTimeClose !== undefined) setDataTimeClose(parsedFilters.dataTimeClose);
            if (parsedFilters.sorteddataTimeClose !== null) setSortedDataTimeClose(parsedFilters.sorteddataTimeClose);

            if (parsedFilters.gv !== undefined) setGv(parsedFilters.gv);
            if (parsedFilters.gvBooleanData !== undefined) setGvBooleanData(parsedFilters.gvBooleanData);
        }
    };

    // айдишник статсуа
    const handleId_statusIdFromChild = (data) =>{
        setStatusIdFromChild(data)
        setSortedStatusIdFromChild(null)
    }
    //получение название статуса
    const hendelStatusNameFromChild = (data) =>{
        setStatusNameFromChild(data);
    }
    // Сортировка статсуа
    const handleSorted_statusIdFromChild = (data) =>{
        setSortedStatusIdFromChild(data)
        setStatusIdFromChild(undefined)
    }

    // айдишник приоритета
    const handleId_prioritiesIdFromChild = (data) =>{
        setPrioritiesIdFromChild(data)
        setSortedPrioritiesIdFromChild(null)
    }
    //получение название приоритета
    const hendelPrioritiesNameFromChild = (data) =>{
        setPrioritiesNameFromChild(data);
    }
    // Сортировка приоритета
    const handleSorted_prioritiesIdFromChild = (data) =>{
        setSortedPrioritiesIdFromChild(data)
        setPrioritiesIdFromChild(undefined)
    }

    // айдишник магазина
    const handleId_ShopIdFromChild = (data) =>{
        setShopIdFromChild(data)
        setSortedShopIdFromChild(null)
    }
    // получение названия магазина
    const hendelShopsNameFromChild = (data) =>{
        setShopNameFromChild(data)
    }
    // Сортировка магазина
    const handleSorted_ShopIdFromChild = (data) =>{
        setSortedShopIdFromChild(data)
        setShopIdFromChild(undefined)
    }

    //  название
    const handleData_nameFromChild = (data) => {
        setNameFromChild(data);
        setSortedNameFromChild(null)
    };
    // Сортировка название
    const handleSorted_NameFromChild = (data) =>{
        setSortedNameFromChild(data)
        setNameFromChild(undefined)
    }

    // айдишник куста
    const handleId_kustIdFromChild = (data) =>{
        setKustIdFromChild(data)
        setSortedKustIdFromChild(null)
    }
    // получение название куста
    const handelKustNameFromChild = (data) =>{
        setKustNameFromChild(data)
    }
    // Сортировка куста
    const handleSorted_KustIdFromChild = (data) =>{
        setSortedKustIdFromChild(data)
        setKustIdFromChild(undefined)
    }

    // айдишник пользоваетля
    const handleId_userIdFromChild = (data) =>{
        setUserIdFromChild(data)
        setSortedUserIdFromChild(null)
    }
    // получение названия пользователя
    const handelUserNameFromChild = (data) =>{
        setUserNameFromChild(data)
    }
    // Сортировка пользователя
    const handelSorded_userIdFronChild = (data)=>{
        setSortedUserIdFromChild(data)
        setUserIdFromChild(undefined)
    }

    // дата начала
    const handleData_dataTimeStart = (data) => {
        setDataTimeStart(data);
        setSortedDataTimeStartAndEnd(null)
    };

    // дата окончания
    const handleData_dataTimeEnd = (data) => {
        setDataTimeEnd(data);
        setSortedDataTimeStartAndEnd(null)
    };

    // Сортировка дат начала и окончания
    const handleData_dataTimeStartAndEnd = (data) => {
        setSortedDataTimeStartAndEnd(data);
        setDataTimeStart(undefined);
        setDataTimeEnd(undefined)
    };

    // дата завершения
    const handleData_dataTimeClose = (data) => {
        setDataTimeClose(data);
        setSortedDataTimeClose(null);
    };

    const handleData_dataTimeCloseFromChild = (data) => {
        setSortedDataTimeClose(data);
        setDataTimeClose(undefined);
    }

    //получение значения по ГВ
    const hendelGVFromChild = (data) =>{
        setGv(data);
    }

    const hendelGFDateFromChild = (data) =>{
        setGvBooleanData(data)
    }

    const LoadData =()=>{
        FetchElements(`${PLANNOGRAMM}/api/v1/statuses`, "GET", setStatuses, navigate,2,() => navigate("/"),handleOpenAlert);
        FetchElements(`${PLANNOGRAMM}/api/v1/priorities`, "GET", setPriorities, navigate,2,() => navigate("/"),handleOpenAlert);
        FetchElements(`${PLANNOGRAMM}/api/v1/shops?task=true`, "GET", setShops, navigate,2,() => navigate("/"),handleOpenAlert);
        FetchElements(`${PLANNOGRAMM}/api/v1/names/tasks`, "GET", setTaskName, navigate,2,() => navigate("/"),handleOpenAlert);
        FetchElements(`${PLANNOGRAMM}/api/v1/kusts`, "GET", setKust, navigate,2,() => navigate("/"),handleOpenAlert);
        FetchElements(`${PLANNOGRAMM}/api/v2/users`, "GET", setUsers, navigate,2,() => navigate("/"),handleOpenAlert);
        if (isInitialized !==false){
            const url = buildUrl();
            FetchElements(
                `${url}${url.includes('?') ? '&' : '?'}limit=${LIMIT}&offset=${offset}`,
                "GET",
                (data) => {
                    if (data.length < LIMIT) {
                        setHasMore(false);
                    } else {
                        setHasMore(true);
                    }
                    setTasks(data);
                    setDataLoading(false);
                },
                navigate,
                2,
                () => navigate("/"),
                handleOpenAlert
            );
        }
    }

    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen(!isOpen);
    };

    ///////////////////////////////////////////////////////////////////////////
    const [selectedItems, setSelectedItems] = useState([]);

    const handleCheckboxChange = (guid) => {
        setSelectedItems((prev) => {
            if (prev.includes(guid)) {
                return prev.filter(item => item !== guid);
            } else {
                return [...prev, guid];
            }
        });
    };

    const handleNavLinkClick = (event) => {
        if (event.target.type === 'checkbox') {
            event.preventDefault();
        }
    };

    function closeTasks() {
        if (isDisabled) {
            handleOpenAlert("Уведомление", "Дождитесь окончания предыдущей операции");
            return;
        }

        lockButton();

        const handleErrorWithUnlock = (title, message, statusCod) => {
            unlockButton();
            handleOpenAlert(title, message, statusCod);
        };

        FetchElements(
            `${PLANNOGRAMM}/api/v1/status/tasks`,
            "PATCH",
            (result) => {
                unlockButton();
                handleOpenAlert('Уведомление', result.message || "Статус задача успешно обновлена!");
                setSelectedItems([]);

                const url = buildUrl();
                FetchElements(
                    `${url}&limit=${LIMIT}&offset=0`,
                    "GET",
                    (data) => {
                        setTasks(data);
                        setDataLoading(false);
                    },
                    navigate,
                    2,
                    () => navigate("/"),
                    handleOpenAlert
                );
            },
            navigate,
            2,
            () => navigate("/"),
            handleErrorWithUnlock,
            0,
            {
                "target_guid": selectedItems,
                "status_id": 4
            },
            [],
            true
        );
    }

    function rolePlay (role){
        if (role === "Планограмщик"){
            return ("flex")
        }else if (role === "Админ"){
            return ("flex")
        }else if (role === "Технолог ГВ"){
            return ("flex")
        }else if (role === "Главный технолог ГВ"){
            return ("flex")
        }else{
            return ("none")
        }
    }

    function clearFilters () {
        setStatusIdFromChild(undefined);
        setStatusNameFromChild(undefined)
        setPrioritiesIdFromChild(undefined);
        setPrioritiesNameFromChild(undefined)
        setNameFromChild(undefined);
        setShopIdFromChild(undefined)
        setShopNameFromChild(undefined)
        setKustIdFromChild(undefined);
        setKustNameFromChild(undefined)
        setUserIdFromChild(undefined);
        setUserNameFromChild(undefined)
        setDataTimeStart(undefined);
        setDataTimeEnd(undefined);
        setDataTimeClose(undefined);
        setGv(undefined);
        setGvBooleanData(undefined);
        sessionStorage.removeItem('taskFilters');
        setClearFull(true);
    }

    function setClearFiltersPerent (data) {
        setClearFull(data);
    }

    return (
        <div>
            <div className="plannogramm_wrapper">
                <div className={`but_filters ${isOpen ? 'openBurger' : ''}`} onClick={handleClick}>
                    Перейти к фильтрам
                </div>

                <div className={`plannogramm_conteiner_data-filters_mobile ${isOpen ? 'visible' : ''}`}>
                    <CustomSearch2 name={"Статус"}
                                   data={statuses}
                                   idSelectedItem={handleId_statusIdFromChild}
                                   dropdown_wrapper_modifikator={"wrapperMode"}
                                   dropdown_header_modifikator={`headerMode`}
                                   clearFull={clearFull}
                                   sendClearFilters={setClearFiltersPerent}
                                   selected={hendelStatusNameFromChild}
                                   sorted={handleSorted_statusIdFromChild}
                                   initialValue={statusNameFromChild}

                    />
                    <CustomSearch2 name={"Приоритет"}
                                   data={priorities}
                                   idSelectedItem={handleId_prioritiesIdFromChild}
                                   dropdown_wrapper_modifikator={"wrapperMode"}
                                   dropdown_header_modifikator={`headerMode`}
                                   clearFull={clearFull}
                                   sendClearFilters={setClearFiltersPerent}
                                   selected={hendelPrioritiesNameFromChild}
                                   sorted={handleSorted_prioritiesIdFromChild}
                                   initialValue={prioritiesNameFromChild}
                    />
                    <CustomSearch2 name={"Название"}
                                   data={taskName}
                                   selected={handleData_nameFromChild}
                                   dropdown_wrapper_modifikator={"wrapperMode"}
                                   dropdown_header_modifikator={`headerMode`}
                                   clearFull={clearFull}
                                   sendClearFilters={setClearFiltersPerent}
                                   sorted={handleSorted_NameFromChild}
                                   initialValue={nameFromChild}
                    />
                    <CustomSearch2 name={"Магазин"}
                                   data={shops}
                                   idSelectedItem={handleId_ShopIdFromChild}
                                   dropdown_wrapper_modifikator={"wrapperMode"}
                                   dropdown_header_modifikator={`headerMode`}
                                   clearFull={clearFull}
                                   sendClearFilters={setClearFiltersPerent}
                                   selected={hendelShopsNameFromChild}
                                   sorted={handleSorted_ShopIdFromChild}
                                   initialValue={shopNameFromChild}
                    />
                    <CustomSearch2 name={"Куст"}
                                   data={kust}
                                   idSelectedItem={handleId_kustIdFromChild}
                                   dropdown_wrapper_modifikator={"wrapperMode"}
                                   dropdown_header_modifikator={`headerMode`}
                                   clearFull={clearFull}
                                   sendClearFilters={setClearFiltersPerent}
                                   selected={handelKustNameFromChild}
                                   sorted={handleSorted_KustIdFromChild}
                                   initialValue={kustNameFromChild}
                    />
                    <CustomSearch2 name={"Кто назначил"}
                                   data={users}
                                   idSelectedItem={handleId_userIdFromChild}
                                   dropdown_wrapper_modifikator={"wrapperMode"}
                                   dropdown_header_modifikator={`headerMode`}
                                   clearFull={clearFull}
                                   sendClearFilters={setClearFiltersPerent}
                                   selected={handelUserNameFromChild}
                                   sorted={handelSorded_userIdFronChild}
                                   initialValue={userNameFromChild}
                    />
                    <CustomSearch2 name={"Дата исполнения"}
                                   data={statuses}
                                   selected={handleData_dataTimeStart}
                                   selected2={handleData_dataTimeEnd}
                                   dropdown_wrapper_modifikator={"wrapperMode"}
                                   clearFull={clearFull}
                                   sendClearFilters={setClearFiltersPerent}
                                   sorted={handleData_dataTimeStartAndEnd}
                                   initialValue={dataTimeStart}
                                   initialValue2={dataTimeEnd}
                    />
                    <CustomSearch2 name={"Дата закрытия"}
                                   data={statuses}
                                   selected={handleData_dataTimeClose}
                                   dropdown_wrapper_modifikator={"wrapperMode"}
                                   sorted={handleData_dataTimeCloseFromChild}
                                   clearFull={clearFull}
                                   sendClearFilters={setClearFiltersPerent}
                                   initialValue={dataTimeClose}
                    />
                    <CustomSearch2
                        name={"ГВ"}
                        data={BoolMass}
                        selected={hendelGVFromChild}
                        idSelectedItem={hendelGFDateFromChild}
                        clearFull={clearFull}
                        sendClearFilters={setClearFiltersPerent}
                        initialValue={gv}
                    />
                    <div onClick={handleClick} className="exitFilters">Показать</div>
                </div>

                <div className="plannogramm_conteiner_buttons" style={{display: rolePlay(role)}}>
                    <div className={"plannogramm_conteiner_buttons_left_buttons"}>
                        <NavLink to={PLANNOGRAMM_ADDTASCK}
                                 className={"button_add_plannogramm_NavLink"}
                                 id={"but_add_wrapper"}
                        >
                            <ButtonPlusImg className={"button_add_plannogramm"}
                                           text={"Добавить задачу"}
                                           img={plus}
                                           divModifier={"button_add"}
                                           key={purposeId()}
                                           classImg={"plussImg"}
                            />
                        </NavLink>
                        <ButtonPlusImg
                            className={"button_add_plannogramm"}
                            text={"Закрыть задачу"}
                            img={closeTasksSVG}
                            divModifier={`button_closeTasks ${selectedItems.length !== 0 ? "button_closeTasks_ACTIVE" : "button_closeTasks_DISABLE"}`}
                            key={purposeId()}
                            classImg={"closeImg"}
                            funck={closeTasks}
                            id="ButCloseTasks"
                            disabled={selectedItems.length === 0}
                        />
                    </div>
                    <div className={"reloadAndClearFiltersContainer"}>
                        <Reload classModificatorDecktop={"reloadPlanogramm"} textModificatorReload={"reloadPlanogrammText"}/>
                        <div className={"button--hint__red but__clear__filters"} onClick={clearFilters}>Очистить фильтры
                            <HandySvg src={trash} className={"trash_icon_class"}/>
                        </div>
                    </div>
                </div>

                <div className="plannogramm_conteiner_data">
                    <table className="plannogramm_table">
                        <thead>
                        <tr>
                            <th className={"Status_filters"}>
                                <CustomSearch2
                                    name={"Статус"}
                                    data={statuses}
                                    idSelectedItem={handleId_statusIdFromChild}
                                    selected={hendelStatusNameFromChild}
                                    sorted={handleSorted_statusIdFromChild}
                                    clearFull={clearFull}
                                    sendClearFilters={setClearFiltersPerent}
                                    initialValue={statusNameFromChild}
                                />
                            </th>
                            <th className={"Priority_filters"}>
                                <CustomSearch2
                                    name={"Приоритет"}
                                    data={priorities}
                                    idSelectedItem={handleId_prioritiesIdFromChild}
                                    selected={hendelPrioritiesNameFromChild}
                                    sorted={handleSorted_prioritiesIdFromChild}
                                    clearFull={clearFull}
                                    sendClearFilters={setClearFiltersPerent}
                                    initialValue={prioritiesNameFromChild}
                                />
                            </th>
                            <th className={"Name_filters"}>
                                <CustomSearch2
                                    name={"Название"}
                                    data={taskName}
                                    selected={handleData_nameFromChild}
                                    sorted={handleSorted_NameFromChild}
                                    clearFull={clearFull}
                                    sendClearFilters={setClearFiltersPerent}
                                    initialValue={nameFromChild}
                                />
                            </th>
                            <th className={"Shops_name_filters"}>
                                <CustomSearch2
                                    name={"Магазин"}
                                    data={shops}
                                    idSelectedItem={handleId_ShopIdFromChild}
                                    selected={hendelShopsNameFromChild}
                                    sorted={handleSorted_ShopIdFromChild}
                                    clearFull={clearFull}
                                    sendClearFilters={setClearFiltersPerent}
                                    initialValue={shopNameFromChild}
                                />
                            </th>
                            <th className={"Kyst_filters"}>
                                <CustomSearch2
                                    name={"Куст"}
                                    data={kust}
                                    idSelectedItem={handleId_kustIdFromChild}
                                    selected={handelKustNameFromChild}
                                    sorted={handleSorted_KustIdFromChild}
                                    clearFull={clearFull}
                                    sendClearFilters={setClearFiltersPerent}
                                    initialValue={kustNameFromChild}
                                />
                            </th>
                            <th className={"Who_appointed_filters"}>
                                <CustomSearch2
                                    name={"Кто назначил"}
                                    data={users}
                                    idSelectedItem={handleId_userIdFromChild}
                                    selected={handelUserNameFromChild}
                                    sorted={handelSorded_userIdFronChild}
                                    clearFull={clearFull}
                                    sendClearFilters={setClearFiltersPerent}
                                    initialValue={userNameFromChild}
                                />
                            </th>
                            <th className={"Date_start_and_end_filters"}>
                                <CustomSearch2
                                    name={"Дата исполнения"}
                                    data={statuses}
                                    selected={handleData_dataTimeStart}
                                    selected2={handleData_dataTimeEnd}
                                    sorted={handleData_dataTimeStartAndEnd}
                                    clearFull={clearFull}
                                    sendClearFilters={setClearFiltersPerent}
                                    initialValue={dataTimeStart}
                                    initialValue2={dataTimeEnd}
                                />
                            </th>
                            <th className={"Date_close_filters"}>
                                <CustomSearch2
                                    name={"Дата закрытия"}
                                    data={statuses}
                                    selected={handleData_dataTimeClose}
                                    sorted={handleData_dataTimeCloseFromChild}
                                    clearFull={clearFull}
                                    sendClearFilters={setClearFiltersPerent}
                                    initialValue={dataTimeClose}
                                />
                            </th>
                            <th className={"Date_gv_filters"}>
                                <CustomSearch2
                                    name={"ГВ"}
                                    data={BoolMass}
                                    selected={hendelGVFromChild}
                                    idSelectedItem={hendelGFDateFromChild}
                                    clearFull={clearFull}
                                    sendClearFilters={setClearFiltersPerent}
                                    initialValue={gv}
                                />
                            </th>
                            <th className={"Colum_burger_menu"}>
                                <div
                                    className="SelectAll"
                                    style={{display: rolePlay(role)}}
                                    onClick={() => {
                                        const eligibleTasks = tasks.filter(task => task.status.id !== 4);
                                        const eligibleGuids = eligibleTasks.map(task => task.target_guid);

                                        const allEligibleSelected = eligibleGuids.every(guid =>
                                            selectedItems.includes(guid)
                                        );

                                        setSelectedItems(allEligibleSelected ? [] : eligibleGuids);
                                    }}
                                >
                                    {selectedItems.length === tasks.filter(t => t.status.id !== 4).length
                                        ? 'Снять все'
                                        : 'Выбрать все'
                                    }
                                </div>
                            </th>
                        </tr>
                        </thead>

                        <tbody>
                        {tasks.map((item, index) => {
                            const isSelected = selectedItems.includes(item.target_guid);
                            const isDone = item.status.name === "Выполнена";
                            const awaitingDone = item.status.name === "Ожидает подтверждения";
                            return (
                                <NavLink to={{pathname: `/PlannogrammTask/${item.target_guid}`}}
                                         state={{target_guid: `${item.target_guid}`, shop_name: `${item.shop.name}`}}
                                         onClick={handleNavLinkClick}
                                         className={"href_to_planogrammTask"}
                                >
                                    <tr
                                        key={item.target_guid}
                                        id={index}
                                        className={`DesctopWersion ${isSelected ? "selected" : ""}${index === 0 ? " first-row" : (index+1 === tasks.length ? " last-row":"")}`}
                                        style={{
                                            backgroundColor: isDone ? "var(--trueColor)" : awaitingDone ? "var(--awaitColor)": (index % 2 === 0 ? "var(--firstColor)" : "var(--twhoColor)"),
                                            color: "var(--font-color)"
                                        }}
                                        ref={index === tasks.length - 10 ? lastTaskElementRefDesktop : null}
                                    >
                                        <td className={`${isSelected ? "selected" : ""}`} style={{ color: isDone ? "black" : "" }}>{item.status.name}</td>
                                        <td className={`${isSelected ? "selected" : ""}`} style={{ color: isDone ? "black" : "" }}>{item.priority.name}</td>
                                        <td className={`${isSelected ? "selected" : ""}`} style={{ color: isDone ? "black" : "" }} title={item.name}>{item.name}</td>
                                        <td className={`${isSelected ? "selected" : ""}`} style={{ color: isDone ? "black" : "" }} title={item.shop.name}>{item.shop.name}</td>
                                        <td className={`${isSelected ? "selected" : ""}`} style={{ color: isDone ? "black" : "" }}>{item.kust.name}</td>
                                        <td className={`${isSelected ? "selected" : ""}`} style={{ color: isDone ? "black" : "" }}>{item.user.fio}</td>
                                        <td className={`${isSelected ? "selected" : ""}`} style={{ color: isDone ? "black" : "" }}>
                                            <div className="flex_orientation">
                                                <div className="gridDateTimeBegin">{item.datetime_begin}</div>
                                                <div className="gridDateTimeEnd">{item.datetime_end}</div>
                                            </div>
                                        </td>
                                        <td className={`${isSelected ? "selected" : ""}`}
                                            style={{ color: isDone ? "black" : "" }}>
                                            {item.datetime_close === null ? "не закрыта" : item.datetime_close}
                                        </td>
                                        <td className={`${isSelected ? "selected" : ""}`}
                                            style={{ color: isDone ? "black" : "" }}>
                                            {item.is_hot_pastries ? "да": "нет"}
                                        </td>
                                        {
                                            (role === "Планограмщик" || role === "Админ" || role === "Технолог ГВ" || role === "Главный технолог ГВ") && (
                                                <td className={`${isSelected ? "selected" : ""}`}>
                                                    <div className="BurgerCheck"
                                                         style={{
                                                             color: item.status.name === "Выполнена" ? "black" : "",
                                                             display: item.status.name === "Выполнена" ? "none" : "",
                                                         }}
                                                    >
                                                        <input
                                                            key={selectedItems.includes(item.target_guid) ? "checked" : "unchecked"}
                                                            type="checkbox"
                                                            className="BurgerCheck_CheckBox"
                                                            checked={selectedItems.includes(item.target_guid)}
                                                            onChange={() => handleCheckboxChange(item.target_guid)}
                                                        />
                                                    </div>
                                                </td>
                                            )
                                        }
                                    </tr>
                                </NavLink>
                            );
                        })}
                        {dataLoading && (
                            <tr>
                                <td colSpan="9" className={"Messages_planogramm_list"}>
                                    Идет загрузка...
                                    <div className="loader"></div>
                                </td>
                            </tr>
                        )}

                        {!dataLoading && tasks.length === 0 && (
                            <tr>
                                <td colSpan="9" className={"Messages_planogramm_list"}>
                                    Планограмм нет
                                </td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>

                <div className={"Planogramm_mobile"}>
                    {
                        tasks.map((item, index) => {
                            return (
                                <div className="MobileWersion">
                                    <NavLink to={{pathname: `/PlannogrammTask/${item.target_guid}`}}
                                             state={{target_guid: `${item.target_guid}`, shop_name: `${item.shop.name}`}}
                                             key={purposeId()}
                                             className="grid_item"
                                    >
                                        <div
                                            className={`plannogramm_conteiner_data-list ${index % 2 === 0 ? "white" : "spase_gray"}`}
                                            id={index}
                                            key={purposeId()}
                                            style={{backgroundColor: item.status.name === "Выполнена" ? "var(--trueColor)" : item.status.name === "Ожидает подтверждения" ? "var(--awaitColor)": (index % 2 === 0 ? "var(--firstColor)" : "var(--twhoColor)")}}
                                            ref={index === tasks.length - 10 ? lastTaskElementRefMobile  : null}
                                        >
                                            <div>
                                                <div className="data_list-item"
                                                     style={{color: item.status.name === "Выполнена" ? "black" : "", fontSize: "1.25rem"}}
                                                >
                                                    {item.name}
                                                </div>
                                            </div>
                                            <div className="gridWrapper">
                                                <div className="gridItems status">
                                                    <div className="gridItemHeader" style={{color: item.status.name === "Выполнена" ? "black" : ""}}>
                                                        Статус:
                                                    </div>
                                                    <div className="data_list-item" style={{color: item.status.name === "Выполнена" ? "black" : ""}}>
                                                        {item.status.name}
                                                    </div>
                                                </div>
                                                <div className="gridItems priority">
                                                    <div className="gridItemHeader" style={{color: item.status.name === "Выполнена" ? "black" : ""}}>
                                                        Приоритет:
                                                    </div>
                                                    <div className="data_list-item" style={{color: item.status.name === "Выполнена" ? "black" : ""}}>
                                                        {item.priority.name}
                                                    </div>
                                                </div>
                                                <div className="gridItems shop">
                                                    <div className="gridItemHeader" style={{color: item.status.name === "Выполнена" ? "black" : ""}}>
                                                        Магазин:
                                                    </div>
                                                    <div className="data_list-item" style={{color: item.status.name === "Выполнена" ? "black" : ""}}>
                                                        {item.shop.name}
                                                    </div>
                                                </div>
                                                <div className="gridItems kust">
                                                    <div className="gridItemHeader" style={{color: item.status.name === "Выполнена" ? "black" : ""}}>
                                                        Куст:
                                                    </div>
                                                    <div className="data_list-item" style={{color: item.status.name === "Выполнена" ? "black" : ""}}>
                                                        {item.kust.name}
                                                    </div>
                                                </div>
                                                <div className="gridItems who_appointed">
                                                    <div className="gridItemHeader" style={{color: item.status.name === "Выполнена" ? "black" : ""}}>
                                                        Назначил:
                                                    </div>
                                                    <div className="data_list-item" style={{color: item.status.name === "Выполнена" ? "black" : ""}}>
                                                        {item.user.fio}
                                                    </div>
                                                </div>
                                                <div className="gridItems data_timeClose">
                                                    <div className="gridItemHeader" style={{color: item.status.name === "Выполнена" ? "black" : ""}}>
                                                        Дата закрытия:
                                                    </div>
                                                    <div className="data_list-item" style={{color: item.status.name === "Выполнена" ? "black" : ""}}>
                                                        {item.datetime_close === null ? "не закрыта" : `${item.datetime_close}`}
                                                    </div>
                                                </div>
                                                <div
                                                    className="gridWrapperDate data_timeStart"
                                                    style={{color: item.status.name === "Выполнена" ? "black" : ""}}
                                                >
                                                    <div className="gridItemHeader">Дата начала:</div>
                                                    <div className="gridDateTimeBegin">{item.datetime_begin}</div>
                                                </div>
                                                <div
                                                    className="gridWrapperDate data_timeEnd"
                                                    style={{color: item.status.name === "Выполнена" ? "black" : ""}}
                                                >
                                                    <div className="gridItemHeader">Дата окончания:</div>
                                                    <div className="gridDateTimeEnd">{item.datetime_end}</div>
                                                </div>
                                                <div className="gridItems GV" style={{flexDirection: "row"}}>
                                                    <div className="gridItemHeader" style={{color: item.status.name === "Выполнена" ? "black" : ""}}>
                                                        ГВ:
                                                    </div>
                                                    <div className="data_list-item" style={{color: item.status.name === "Выполнена" ? "black" : ""}}>
                                                        {item.is_hot_pastries ? "да" :"нет"}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            )
                        })
                    }
                    {dataLoading && (
                        <tr>
                            <td colSpan="9" className={"Messages_planogramm_list"}>
                                Идет загрузка...
                                <div className="loader"></div>
                            </td>
                        </tr>
                    )}

                    {!dataLoading && tasks.length === 0 && (
                        <tr>
                            <td colSpan="9" className={"Messages_planogramm_list"}>
                                Планограмм нет
                            </td>
                        </tr>
                    )}
                </div>
            </div>
            <CustomAlert
                title={alertTitle}
                message={alertMessage}
                statusCod={alertStatusCod}
                isOpenAlert={isOpenAlert}
                onClose={handleCloseAlert}
            />
        </div>
    );
};
export default PlannogrammList;

